import { AppName } from '@packages/shared/core/common/entities';
import type { DomainLocale } from '@packages/shared/core/common/entities';
import { QueryCacheProviderOptions } from '@packages/shared/core/queryCache/entities';

export enum AppEnvironment {
  LOCAL = 'local',
  DEV = 'dev',
  STAGE = 'stage',
  PRODUCTION = 'production',
}

export interface Config {
  env: AppEnvironment;
  appVersion: string;
  projectName: string;
  appName: AppName;
  domainLocale: DomainLocale;
  appOrigin: {
    default: string;
    asknebula: string;
    asknebulaNl: string;
    mainApp: string;
    guidance: string;
    birthcharts: string;
  };
  domainRoot: string;
  services: {
    baseUrl: string;
    askGatewayUrl: string;
    expertsDealerUrl: string;
  };
  amplitudeApiKey: string;
  amplitudeProxyUrl: string;
  googleAnalyticsId: string;
  googleClientId: string;
  googleMapApiKey: string;
  googleMapEmbedBaseUrl: string;
  smartlook: {
    apiKey: string;
    setupDelay: number;
  };
  geoCodeUrl: string;
  geoCodeApiKey: string;
  testingTokenCookieKey: string;
  isProduction: boolean;
  isStage: boolean;
  sentryDsn: string;
  aiSimpleRegFunnel: string;
  contentManager: {
    baseUrl: string;
    apiToken: string;
    clientToken: string;
  };
  growthbook: {
    apiHost: string;
    clientKey: string;
  };
  googleAnalytics: {
    apiUrl: string;
    measurementId: string;
    apiSecret: string;
    clientIdKey: string;
    sessionIdKey: string;
    engagementTime: string;
  };
  defaultQueryCacheProviderOptions: QueryCacheProviderOptions;
  buildCache: {
    path: string;
  };
  oneTrust: {
    key: string;
  };
  remoteAssetsStorageUrl: string;
  facebookAuthAppId: string;
  grafanaLogger: {
    url: string;
  };
  clarityId: string;
  gtmId: string;
  supportBotApiKey: string;
  verification: {
    trustpilotVerificationId: string;
    facebookVerificationId: string;
  };
  trustpilot: {
    businessUnitId: string;
    token: string;
    templateId: string;
    reviewUrl: string;
  };
  observability: {
    defaultTracerName: string;
    tracesUrl: string;
    browser: {
      httpInstrumentationIgnoreUrls: Array<string | RegExp>;
      httpInstrumentationSpanRate: number;
    };
    server: {
      httpInstrumentationIgnoreOutGoingUrls: Array<string | RegExp>;
      httpInstrumentationIgnoreIncomingUrls: Array<string | RegExp>;
      httpInstrumentationSpanRate: number;
    };
  };
}
